import {NgModule, Pipe, PipeTransform} from '@angular/core';
import {SafePipe} from "./safe.pipe";

@Pipe({
    name: 'trim',
    standalone: false
})
export class TrimPipe implements PipeTransform {
    transform(value: any) {
        if (!value) {
            return '';
        }
        return value.trim();
    }
}

@NgModule({
    declarations: [TrimPipe],
    exports: [TrimPipe],
})
export class TrimPipeModule {}
